<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
          <el-form-item label="用户ID" prop="userId">
          <el-input v-model="dataForm.userId" placeholder="用户ID"></el-input>
      </el-form-item>
          <el-form-item label="状态 0：申请提现 1：提现成功，2：提现失败" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态 0：申请提现 1：提现成功，2：提现失败"></el-input>
      </el-form-item>
          <el-form-item label="" prop="bankNo">
          <el-input v-model="dataForm.bankNo" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="所属银行" prop="bank">
          <el-input v-model="dataForm.bank" placeholder="所属银行"></el-input>
      </el-form-item>
          <el-form-item label="支行" prop="branch">
          <el-input v-model="dataForm.branch" placeholder="支行"></el-input>
      </el-form-item>
          <el-form-item label="账户总额" prop="money">
          <el-input v-model="dataForm.money" placeholder="账户总额"></el-input>
      </el-form-item>
          <el-form-item label="到账金额" prop="amount">
          <el-input v-model="dataForm.amount" placeholder="到账金额"></el-input>
      </el-form-item>
          <el-form-item label="0处理中1成功2失败" prop="feeStatus">
          <el-input v-model="dataForm.feeStatus" placeholder="0处理中1成功2失败"></el-input>
      </el-form-item>
          <el-form-item label="手续费划拨编号" prop="feeBizFlow">
          <el-input v-model="dataForm.feeBizFlow" placeholder="手续费划拨编号"></el-input>
      </el-form-item>
          <el-form-item label="手续费" prop="fee">
          <el-input v-model="dataForm.fee" placeholder="手续费"></el-input>
      </el-form-item>
          <el-form-item label="手续费收取方式 1：平台垫付 2：个人承担" prop="feeBear">
          <el-input v-model="dataForm.feeBear" placeholder="手续费收取方式 1：平台垫付 2：个人承担"></el-input>
      </el-form-item>
          <el-form-item label="汇付手续费收取方式 1：内扣 2：外扣" prop="feeType">
          <el-input v-model="dataForm.feeType" placeholder="汇付手续费收取方式 1：内扣 2：外扣"></el-input>
      </el-form-item>
          <el-form-item label="提现方式：0--T+0，1---T+1  2---T+5" prop="type">
          <el-input v-model="dataForm.type" placeholder="提现方式：0--T+0，1---T+1  2---T+5"></el-input>
      </el-form-item>
          <el-form-item label="取现订单号" prop="orderNo">
          <el-input v-model="dataForm.orderNo" placeholder="取现订单号"></el-input>
      </el-form-item>
      <el-form-item label="添加时间" prop="addTime">
          <!-- <el-input v-model="dataForm.addTime" placeholder="添加时间"></el-input> -->
          <el-date-picker
                  v-model="dataForm.addTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="添加IP" prop="addIp">
          <el-input v-model="dataForm.addIp" placeholder="添加IP"></el-input>
      </el-form-item>
      <el-form-item label="审核时间" prop="verifyTime">
          <!-- <el-input v-model="dataForm.verifyTime" placeholder="审核时间"></el-input> -->
          <el-date-picker
                  v-model="dataForm.verifyTime"
                  type="date"
                  placeholder="选择预算日期"
                  value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
      </el-form-item>
          <el-form-item label="审核人" prop="verifyUserName">
          <el-input v-model="dataForm.verifyUserName" placeholder="审核人"></el-input>
      </el-form-item>
          <el-form-item label="审核备注" prop="verifyRemark">
          <el-input v-model="dataForm.verifyRemark" placeholder="审核备注"></el-input>
      </el-form-item>
          <el-form-item label="提现券ID，0：未使用提现券" prop="feeRedenvelope">
          <el-input v-model="dataForm.feeRedenvelope" placeholder="提现券ID，0：未使用提现券"></el-input>
      </el-form-item>
          <el-form-item label="第三方流水号" prop="bizFlow">
          <el-input v-model="dataForm.bizFlow" placeholder="第三方流水号"></el-input>
      </el-form-item>
          <el-form-item label="商户手续费" prop="merchantFee">
          <el-input v-model="dataForm.merchantFee" placeholder="商户手续费"></el-input>
      </el-form-item>
          <el-form-item label="对账状态" prop="reconStatus">
          <el-input v-model="dataForm.reconStatus" placeholder="对账状态"></el-input>
      </el-form-item>
              <!-- <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
          <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item> -->
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        userId: '',
        status: '',
        bankNo: '',
        bank: '',
        branch: '',
        money: '',
        amount: '',
        feeStatus: '',
        feeBizFlow: '',
        fee: '',
        feeBear: '',
        feeType: '',
        type: '',
        orderNo: '',
        addTime: '',
        addIp: '',
        verifyTime: '',
        verifyUserName: '',
        verifyRemark: '',
        feeRedenvelope: '',
        bizFlow: '',
        merchantFee: '',
        reconStatus: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteTime: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        userId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bank: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        branch: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        money: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        amount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        feeStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        feeBizFlow: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        fee: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        feeBear: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        feeType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        orderNo: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        addTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        addIp: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        verifyTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        verifyUserName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        verifyRemark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        feeRedenvelope: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bizFlow: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        merchantFee: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        reconStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/slaccountcash/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/slaccountcash/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
